const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 396.8 396.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC9966"
    },
    d: "M325.6,22H71.2C44.1,22,22,44.1,22,71.2v254.4c0,27.1,22.1,49.2,49.2,49.2h254.4 c27.1,0,49.2-22.1,49.2-49.2V71.2C374.8,44.1,352.7,22,325.6,22z M304.1,80.9c-2.7-11.3,4-22.8,15-25.6c1.8-0.4,3.6-0.6,5.3-0.6 c9.7,0,18,6.4,20.3,15.7c2.7,10.6-4.2,22.1-15.3,25.5c-1.9,0.4-3.4,0.4-5.4,0.4C314.8,96.4,306.2,89.7,304.1,80.9z M198.4,90 c58.4,0,106,47.6,106,106s-47.6,106-106,106s-106-47.6-106-106S140,90,198.4,90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#875426"
    },
    d: "M343.2,70.7c-2.2-8.5-10.4-14.9-19.2-14.9c-1.1,0-3.3,0-5.3,1.2c-4.7,1.2-8.8,4.3-11.3,8.4 c-2.7,4.5-3.4,9.9-1.9,15c1.9,8.7,9.3,14.8,18.3,14.8c1.8,0,3.6-0.3,5.4-0.8c5.1-1.1,9.5-4.2,12.1-8.6 C344.1,81.3,344.7,75.8,343.2,70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M310.4,79.2c2.4,8,10.4,12.8,17.6,10.4c8-2.4,12.8-10.4,10.4-17.6c-1.6-6.4-8-11.2-14.4-11.2 c-0.8,0-2.4,0-4,0.8C312.8,63.2,308,71.2,310.4,79.2z M354.4,68c4,16.8-5.6,32.8-22.4,37.6c-2.4,0.8-4.8,0.8-8,0.8 c-13.6,0-26.4-9.6-29.6-23.2c-4-16,5.6-32.8,22.4-37.6C332.8,41.6,349.6,51.2,354.4,68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9CDC1"
    },
    d: "M198.4,114.6c41.6-0.4,75.2,40.6,75.2,82.2S240,272,198.4,272s-82.1-33.6-82.2-75.2 C116.1,148,153.4,115,198.4,114.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF8EF"
    },
    d: "M214.4,137.6c-41.6,0-75.2,33.6-75.2,75.2c0,16.8,5.6,32,14.4,44c12.8,8.8,28,14.4,44,14.4 c41.6,0,75.2-33.6,75.2-75.2c0-16.8-5.6-32-14.4-44C246.4,143.2,231.2,137.6,214.4,137.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M198.4,100.8c53.1,0,96,42.9,96,96s-42.9,96-96,96s-96-42.9-96-96S145.3,100.8,198.4,100.8z  M272.8,196c0-41.6-33.6-75.2-75.2-75.2s-75.2,33.6-75.2,75.2s33.6,75.2,75.2,75.2S272.8,237.6,272.8,196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#875426"
    },
    d: "M288.8,196c0-50.4-40.8-91.2-91.2-91.2s-91.2,40.8-91.2,91.2s40.8,91.2,91.2,91.2 C248.8,287.2,288.8,246.4,288.8,196z M298.4,196c0,55.2-44.8,100-100,100s-100-44.8-100-100s44.8-100,100-100S298.4,140.8,298.4,196 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M198.4,296c55.2,0,100-44.8,100-100s-44.8-100-100-100s-100,44.8-100,100S143.2,296,198.4,296z  M314.4,196c0,64-52,116-116,116s-116-52-116-116s52-116,116-116S314.4,132,314.4,196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#996632"
    },
    d: "M329.7,5H67.1C32.8,5,5,32.9,5,67.1v262.5c0,34.3,27.9,62.1,62.1,62.1h262.5 c34.3,0,62.1-27.9,62.1-62.1V67.1C391.8,32.9,363.9,5,329.7,5z M365,328.8c0,19.5-15.8,35.3-35.3,35.3h-5.2v0.8H67.1 c-19.5,0-35.3-15.8-35.3-35.3V67.1c0-19.5,15.8-35.3,35.3-35.3h262.5c19.5,0,35.3,15.8,35.3,35.3v261.7H365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M325.6,0c39.2,0,71.2,32,71.2,71.2v254.4c0,39.2-32,71.2-71.2,71.2H71.2C32,396.8,0,364.8,0,325.6 V71.2C0,32,32,0,71.2,0H325.6z M380.8,71.2c0-30.4-24.8-55.2-55.2-55.2H71.2C40.8,16,16,40.8,16,71.2v254.4 c0,30.4,24.8,55.2,55.2,55.2h254.4c30.4,0,55.2-24.8,55.2-55.2L380.8,71.2L380.8,71.2z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.da82436494f9a268dab8983ec2804e57.svg";
export { ForwardRef as ReactComponent };